import * as React from 'react'

import { DetailInfo } from '../../../components/Detail/DetailInfo'
import { useProductDetailDataCtx } from '../contexts/ProductDetailStateProvider'

type TProps = NoChildren &
  Pick<PropsOf<typeof DetailInfo>, 'hasStickyHeading' | 'horizontalPadding'>

/**
 * DetailInfo connected to product detail context data.
 */
export const ProductDetailInfo: React.FC<TProps> = (props) => {
  const { product } = useProductDetailDataCtx()

  return (
    <DetailInfo
      {...props}
      nameLabel={product.nameLabel}
      allergens={product.allergens}
      descriptionLabel={product.descriptionLabel}
      ageControl={product.ageControl}
    />
  )
}
